import * as Api from '@ViewModels';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../../../components-v2/Input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components-v2/Select';
import { FormFieldWrapper } from '../../shared/components/FormFieldWrapper';
import { styleSheet } from '../styles';
import { EventRegistrationFormData } from '../utils';

const registrationModeOptions = [
	{ value: Api.EventRegistrationMode.Levitate, label: 'Levitate registration form' },
	{ value: Api.EventRegistrationMode.ExternalLink, label: 'External link' },
	{ value: Api.EventRegistrationMode.InformationOnly, label: 'Information only' },
];

export const RegistrationModeField = () => {
	const { control, watch } = useFormContext<EventRegistrationFormData>();
	const registrationMode = watch('registrationMode');

	return (
		<>
			<FormFieldWrapper
				name='registrationMode'
				control={control}
				title='Registration'
				description='Where the Register button on your public events page sends people. Information only lists the event without a Register button. The Levitate registration link keeps working for anyone who already has it.'
				textWrapperStyles={[styleSheet.registrationModeText]}
				controllerWrapperStyles={[styleSheet.controllerWrapper, styleSheet.registrationModeRow]}
			>
				{({ value, onChange }) => (
					<Select value={value} onValueChange={val => onChange(val as Api.EventRegistrationMode)}>
						<SelectTrigger id='registration-mode-select' styles={styleSheet.registrationModeTrigger}>
							<SelectValue>{registrationModeOptions.find(option => option.value === value)?.label}</SelectValue>
						</SelectTrigger>
						<SelectContent>
							{registrationModeOptions.map(option => (
								<SelectItem key={option.value} value={option.value}>
									{option.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				)}
			</FormFieldWrapper>
			{registrationMode === Api.EventRegistrationMode.ExternalLink && (
				<FormFieldWrapper
					name='externalRegistrationUrl'
					control={control}
					title='Registration Link'
					description='The page people register or buy tickets at, such as a PayPal or Google Forms page'
					controllerWrapperStyles={[styleSheet.controllerWrapper]}
				>
					{({ value, onChange, onBlur, ref }) => (
						<Input
							id='external-registration-url-input'
							ref={ref}
							type='url'
							value={value}
							onChange={e => onChange(e.target.value)}
							onBlur={onBlur}
							placeholder='https://'
						/>
					)}
				</FormFieldWrapper>
			)}
		</>
	);
};
